import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { currencyOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { GridApi } from 'ag-grid-community';
import { IstStudyTeamOrganizationViewModalComponent } from '../../ist-study-team-organization/ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { IstStudyTeamAddOrRoleComponent } from '../ist-study-team-add-or-role/ist-study-team-add-or-role.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../../services/common.service';
import { UserService } from '../../../../services/user.service';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from '../../../../models/common';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FileService } from '../../../../services/file.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-ist-study-team-team-view-modal',
  templateUrl: './ist-study-team-team-view-modal.component.html',
  styleUrls: ['./ist-study-team-team-view-modal.component.scss']
})
export class IstStudyTeamTeamViewModalComponent implements OnInit {

  formFields: any;
  titleOptions: any = [];
  columnDefs: any;
  operations: any;
  gridApi: GridApi;
  selectedRow: any;
  rowData: any;
  gridOptions: any;
  loadTeam = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  currencyOptions = currencyOptionsConstant;
  frameworkComponents;
  context;
  ApplicationID: any;
  FilesList: any = [];
  Listfiles: any = [];
  userType: string = "";
  documaent_attach_list: Document_Upload_File[] = [];
  IsMultipermission: string = "yes";
  IsClicked = false;
  RolesList: any = [];
  AttachementIds: string = "";
  permission: string = "";
  IsAdmin: string = "";
  @Input() public Content: any;
  staticformFields: any;
  appStatus: boolean = false;
  Application_Type_ID: string = "";
  ModelData: any = null;
  submittedresponse: SCREEN_RESPONSE[] = [];
  IsFormToched: boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: any;
  genInfoFieldControls: any;
  SCREEN_MODEL: any = null;
  Currency_ID: string = "";
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private istDatashareserivse: IstDataShareService,
    public commonService: CommonService,
    private userService: UserService,
    public datepipe: DatePipe,
    public fileService: FileService
  ) {

  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  ngOnInit() {
    this.istDatashareserivse.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      this.GetScreenConfigControls('SCR-002');
      if (!this.ApplicationID) {
        this.GetIstGenInfoScreenConfigControls();
      }
    });
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.istDatashareserivse.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
   if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.istDatashareserivse.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.permission = "";
    this.appStatus = this.commonService.getIstStatus();

    if (this.commonService.getPagePermission("IST02") != null && this.commonService.getPagePermission("IST02") != undefined) {
      this.permission = this.commonService.getPagePermission("IST02").toLowerCase();
    }

    this.columnDefs = [
      {
        "headerName": "Organization",
        "field": "MemberOrganizationName",
      },
      {
        "headerName": "User Role",
        "field": "RoleName",
      }
    ]

    this.rowData = [];
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
        IsRequiredEdit: true
      }
    }

    this.context = { componentParent: this };
    this.frameworkComponents = {
      deleteRenderer: EditAndDeleteOperationsRenderer
    };

    this.files = [];
    this.userType = this.userService.getUserType();

    setTimeout(() => {
      this.loadTeam = true;
    }, 350);



    if (this.Content?.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      if (this.Content?.heading == "Edit" || this.Content?.heading == "View") {
        this.getStudyTeamData();
        this.GetGridData();
      }
    });
  }

  GetGridData() {
    this.summaryService.getScreenDataForEdit("api/ISTStudyTeam/GridDataEdit?RecordID1="
      + this.Content?.content?.id + "&ApplicationID1=" + this.ApplicationID)
      .subscribe(result => {
        this.loadTeam = false;
        this.rowData = this.setOperations(result);
        setTimeout(() => {
          this.loadTeam = true;
        }, 200);
      });
  }

  getStudyTeamData() {
    this.summaryService.getScreenDataForEdit(
      "api/ISTStudyTeam/Edit?RecordID=" + this.Content?.content?.id
      + "&ApplicationID=" + this.ApplicationID)
      .subscribe(result => {
        if (result != null) {
          this.ModelData = result;
          this.permission = result["PERMISSION"];
          this.BindDataToDynamicControls();
          this.BindDataToStaticControls(result);
        }
      });
  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-002";
      sr.RowId = this.Content?.content?.id;
      sr.AppId = this.ApplicationID;
      this.summaryService.getISTScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields?.length; i++) {
            let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }
                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  let options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;
                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    // let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'dd-MMM-yyyy');
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }
                }
              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }
      });
    }
  }

  BindDataToStaticControls(MainObjData: any): any {
    for (let i = 0; i < this.staticformFields?.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "TITLE":
          this.staticformFields[i].ControlValue = MainObjData.Modal.TITLE;
          break;
        case "FIRST_NAME":
          this.staticformFields[i].ControlValue = MainObjData.Modal.FIRST_NAME;
          break;
        case "MIDDLE_NAME":
          this.staticformFields[i].ControlValue = MainObjData.Modal.MIDDLE_NAME;
          break;
        case "LAST_NAME":
          this.staticformFields[i].ControlValue = MainObjData.Modal.LAST_NAME;
          break;
        case "LICENSE_NO":
          this.staticformFields[i].ControlValue = MainObjData.Modal.LICENSE_NO;
          break;
        case "OCCUPATION":
          this.staticformFields[i].ControlValue = MainObjData.Modal.OCCUPATION;
          break;
        case "SPECIALIZATION":
          this.staticformFields[i].ControlValue = MainObjData.Modal.SPECIALIZATION;
          break;
        case "ADDRESS":
          this.staticformFields[i].ControlValue = MainObjData.Modal.ADDRESS;
          break;
        case "PHONE":
          this.staticformFields[i].ControlValue = MainObjData.Modal.PHONE;
          break;
        case "EMAIL":
          this.staticformFields[i].ControlValue = MainObjData.Modal.EMAIL;
          break;
        case "StudyTeam_Upload":
          this.staticformFields[i].UploadFiles = MainObjData.Modal.StudyTeam_Upload;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }

  }

  // ApplyConditions($event, question, makeNull) {
  //   let value = $event.value;
  //   if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
  //     question.Control_Condtions = [];
  //   }
  //   let displayControlIDS = [];
  //   let hideControlIDS = [];
  //   let enableControlIDS = [];
  //   let disbledControlIDS = [];


  //   question.Control_Condtions.forEach((item) => {
  //     if (item.Mapped_Control_Value == value) {
  //       item.ConditionsList.forEach((otemCon) => {
  //         switch (otemCon.Mapped_Condtion) {
  //           case "1": //display
  //             if (displayControlIDS.length == 0) {
  //               displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (disCntrIds && disCntrIds.length > 0) {
  //                 disCntrIds.forEach((id) => {
  //                   if (!displayControlIDS.includes(id)) {
  //                     displayControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }

  //             break;
  //           case "2": //enabled
  //             if (enableControlIDS.length == 0) {
  //               enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (enableCntrIds && enableCntrIds.length > 0) {
  //                 enableCntrIds.forEach((id) => {
  //                   if (!enableControlIDS.includes(id)) {
  //                     enableControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }
  //             break;
  //           case "3": //hide
  //             if (hideControlIDS.length == 0) {
  //               hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (hideCntrIds && hideCntrIds.length > 0) {
  //                 hideCntrIds.forEach((id) => {
  //                   if (!hideControlIDS.includes(id)) {
  //                     hideControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }

  //             break;

  //           case "4": //disabled
  //             if (disbledControlIDS.length == 0) {
  //               disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //             }
  //             else {
  //               let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
  //               if (disableCntrIds && disableCntrIds.length > 0) {
  //                 disableCntrIds.forEach((id) => {
  //                   if (!disbledControlIDS.includes(id)) {
  //                     disbledControlIDS.push(id);
  //                   }
  //                 })
  //               }
  //             }
  //             break;
  //         }

  //       });
  //     }
  //   })


  //   //default
  //   if (value != "") {
  //     if (this.staticformFields) {
  //       this.staticformFields.forEach((con) => {          
  //         if (displayControlIDS.indexOf(con.ID) > -1) {
  //           con.IS_Dependent_Display = true;
  //           if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //           if (con.CONTROL == "10") {
  //             con.ControlValue = [];
  //           }
  //           if (con.CONTROL == "4")
  //             this.UpdateParentChildDetails(con);
  //         }
  //         if (hideControlIDS.indexOf(con.ID) > -1) {
  //           con.IS_Dependent_Display = false;
  //           if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //           if (con.CONTROL == "10") {
  //             con.ControlValue = [];
  //           }
  //           if (con.CONTROL == "4")
  //             this.UpdateParentChildDetails(con);
  //         }
  //         if (enableControlIDS.indexOf(con.ID) > -1) {
  //           con.IS_Dependent_Enabled = true;
  //           if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //           if (con.CONTROL == "10") {
  //             con.ControlValue = [];
  //           }
  //           if (con.CONTROL == "4")
  //             this.UpdateParentChildDetails(con);
  //         }
  //         if (disbledControlIDS.indexOf(con.ID) > -1) {
  //           con.IS_Dependent_Enabled = false;
  //           if(makeNull == "Y")
  //         {
  //           con.ControlValue = "";
  //         }
  //           if (con.CONTROL == "10") {
  //             con.ControlValue = [];
  //           }
  //           if (con.CONTROL == "4")
  //             this.UpdateParentChildDetails(con);
  //         }
  //       });
  //     }
  //   }
  // }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }


  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })
    if (this.staticformFields) {
      this.staticformFields.forEach((con) => {
        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
        }
      });
    }
  }

  addRow() {
    let modalRef = this.modalService.open(IstStudyTeamAddOrRoleComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    let tempstaticformFields = this.staticformFields?.filter(x => x.FIELD_CODE == 'StudyTeam_Org' || x.FIELD_CODE == 'StudyTeam_UserRole');
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: this.Content?.content?.id,
        ApplicationID: this.ApplicationID,
        rowDataRoles: this.rowData,
        staticformFields: tempstaticformFields
      }
    }
    modalRef.result.then(result => {
      this.loadTeam = false;
      this.rowData.push(result);
      this.rowData = this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadTeam = true;
      }, 100);
    });
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  onRowDoubleClicked(event) { }

  ClosePopup() {
    this.modalRef.close();
  }

  SaveStudyTeam() {
    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields?.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        let uploadData = new FormData();

        this.RolesList = [];
        if (this.rowData != null && this.rowData.length > 0) {
          for (let j = 0; j < this.rowData.length; j++) {
            let obj = {
              "ID":this.rowData[j].ID,
              "MemberOrganizationId": this.rowData[j].MemberOrganizationId,
               "MemberOrganizationName": this.rowData[j].MemberOrganizationName,
              "RoleId": this.rowData[j].RoleId, 
              "RoleName": this.rowData[j].RoleName
            };
            this.RolesList.push(obj);
          }
        }

        if (this.Content?.heading == "Add") {
          if (!this.ApplicationID) {
            this.SaveIST_GI_APP().subscribe((res) => {
              if (res.Status === 0) {
                //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
                let FinalControls = _.cloneDeep(this.staticformFields);
                FinalControls.forEach((item) => {
                  switch (item.CONTROL) {
                    case 10:
                      item.ControlValue = null;
                      break;
                  }
                });
                uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
                this.ApplicationID = res["TransactionID"];
                this.istDatashareserivse.setApplicationID(this.ApplicationID);
                uploadData.append("Appid", this.ApplicationID);
                uploadData.append("Application_Type_ID", this.Application_Type_ID);
                uploadData.append("MemberOrganizationsList", JSON.stringify(this.RolesList));
                this.summaryService.SaveStudyTeam("api/ISTStudyTeam/Insert", uploadData).subscribe((result) => {
                  if (result.Status === 0) {
                    this.commonService.SuccessBanner(result.Message);
                    this.commonService.refreshPage(this.ApplicationID);
                    this.modalRef.close();
                    this.IsClicked = false;
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
              else {
                this.commonService.ValidationBanner(res.Message);
              }
            })
          }
          else {
            //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
            let FinalControls = _.cloneDeep(this.staticformFields);
            FinalControls.forEach((item) => {
              switch (item.CONTROL) {
                case 10:
                  item.ControlValue = null;
                  break;
              }
            });
            uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
            uploadData.append("Appid", this.ApplicationID);
            uploadData.append("Application_Type_ID", this.Application_Type_ID);
            uploadData.append("MemberOrganizationsList", JSON.stringify(this.RolesList));
            this.summaryService.SaveStudyTeam("api/ISTStudyTeam/Insert", uploadData).subscribe((result) => {
              if (result.Status === 0) {
                this.commonService.SuccessBanner(result.Message);
                this.modalRef.close();
                this.Content.heading = "Edit";
                this.IsClicked = false;
              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });

          }
        }
        else {
          //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
          let FinalControls = _.cloneDeep(this.staticformFields);
          FinalControls.forEach((item) => {
            switch (item.CONTROL) {
              case 10:
                item.ControlValue = null;
                break;
            }
          });
          uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
          uploadData.append("Appid", this.ApplicationID);
          uploadData.append("ID", this.Content?.content?.id);
          uploadData.append("SavedAttachements", this.AttachementIds);
          uploadData.append("DeletedFiles", this.Listfiles);
          uploadData.append("MemberOrganizationsList", JSON.stringify(this.RolesList));
          let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
          if (!inactiveValueControls || inactiveValueControls.length == 0) {
            this.summaryService.SaveStudyTeam("api/ISTStudyTeam/Update", uploadData).subscribe(result => {
              if (result.Status === 0) {
                if (result.ErrorCode === "NOCHANGES") {
                  this.getStudyTeamData();
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(result.Message);
                  this.modalRef.close();
                  this.Content.heading = "Edit";
                }
                this.IsClicked = false;
              }
              else {
                this.getStudyTeamData();
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
          else {
            let dataMsg = inactiveValueControls.join("</br>");
            this.commonService.ValidationBanner(dataMsg);
          }
        }
      }
    }
  }

  DeleteSavedUpload(item): void {
    this.commonService.CheckIsFileIsRefereancedInReviw(item).subscribe((x) => {
      if (x["Status"] == 2 && x["Data"] == false) {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else {
        let code = item;
        this.FilesList.forEach(sec => {
          if (sec.ID === code) {
            if (this.AttachementIds != null && this.AttachementIds != "" && this.AttachementIds != null)
              this.AttachementIds += "," + sec.ID + ",";
            else
              this.AttachementIds = sec.ID;
            let isExist = this.FilesList.findIndex((r: any) => r.ID === code);
            if (isExist != -1) {
              this.FilesList.splice(isExist, 1);
            }
          }
        });
      }
    });
  }

  SaveUploadAttachment(id): void {

    let Url = serviceConstants.apiURL + "api/ISTStudyTeam/UploadFiles?TransactionID=" + id;
    const event: any = {
      type: 'uploadAll',
      url: Url,
      method: 'POST',
      data: { Id: "" },
    };

    this.uploadInput.emit(event);
    this.files = [];
  }

  addNewOrg() {

    let modalRef = this.modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {
        id: this['self']?.Content?.content?.id,
        ApplicationID: this.ApplicationID
      }
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    if (this.staticformFields) {
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
          switch (item.CONTROL) {
            case 1:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              else {
                if (item.FIELD_CODE == 'EMAIL') {
                  if (this.commonService.validateEmail(item.ControlValue)) {
                    $("#dynmcId" + item["ID"]).addClass("ng-untouched ng-valid");
                    $("#dynmcId" + item["ID"]).removeClass("ng-touched ng-invalid validate-error");

                  }
                  else {
                    $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                    $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                    message += `Please enter valid ${item.LABEL} <br/>`;
                    isValid = false;
                  }
                }
              }
              break;
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:

              if (!item.ControlValue) {
                if (item.FIELD_CODE != 'StudyTeam_UserRole') {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }

              }
              break;
            case 10:

              if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }


              break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 7:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
        else {
          switch (item.CONTROL) {
            case 1:
              if (item.ControlValue) {
                if (item.FIELD_CODE == 'EMAIL') {
                  if (this.commonService.validateEmail(item.ControlValue)) {
                    $("#dynmcId" + item["ID"]).addClass("ng-untouched ng-valid");
                    $("#dynmcId" + item["ID"]).removeClass("ng-touched ng-invalid validate-error");

                  }
                  else {
                    $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                    $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                    message += `Please enter valid ${item.LABEL} <br/>`;
                    isValid = false;
                  }
                }
              }
              break;
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
            case 10:
            case 6:
            case 7:
            case 8:
            case 9:
          }
        }
      });
    }


    //Check atleast single field value exists
    if (isValid) {
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter atleast one field. <br/>`;
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  edit() {
    let MemOrgId = this['self'].selectedRow['MemberOrganizationId'];
    let RoleId = this['self'].selectedRow['RoleId'];
    let MemOrgName = this['self'].selectedRow['MemberOrganizationName'];
    let RoleName = this['self'].selectedRow['RoleName'];
    let modalRef = this['self'].modalService.open(IstStudyTeamAddOrRoleComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-sm right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: {
        id: this['self']?.Content?.content?.id,
        ApplicationID: this.ApplicationID,
        MemberOrganizationId: MemOrgId, RoleId: RoleId,
        OrganizationName: MemOrgName,
        RoleName: RoleName,
        rowDataRoles: this['self'].rowData
      }
    }

    modalRef.result.then(result => {
      this['self'].loadTeam = false;
      let isOrgExist = this['self'].rowData.findIndex((Role: any) => Role.MemberOrganizationId == result.MemberOrganizationId);
      if (isOrgExist != -1) {
        this['self'].rowData.splice(isOrgExist, 1);
      }
      this['self'].rowData.push(result);
      this['self'].rowData = this['self'].setOperations(this['self'].rowData);
      setTimeout(() => {
        this['self'].loadTeam = true;
      }, 100);
    })

  }

  delete() {
    let MemOrgId = this['self'].selectedRow['MemberOrganizationId'];
    let isOrgExist = this['self'].rowData.findIndex((Role: any) => Role.MemberOrganizationId == MemOrgId);
    if (isOrgExist != -1) {
      this['self'].rowData.splice(isOrgExist, 1);
    }
    this['self'].rowData = this['self'].setOperations(this['self'].rowData);
    this['self'].loadTeam = false;
    setTimeout(() => {
      this['self'].loadTeam = true;
    }, 200);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }
  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.istDatashareserivse);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    return this.operations;
  }

  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];

    let tempoperations2 = [];

    RawData.forEach(element => {
      if (this.permission == "view" || this.Content?.heading == 'View') {

        element["Operations"] = this.setDef(tempoperations2);
      }
      else {

        element["Operations"] = this.setDef(tempoperations);
      }
    });
    return RawData;
  }

  showFiles() {
    ;
    let files = '';
    if (this.files && this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        files += this.files[i].name;
        if (!(this.files.length - 1 === i)) {
          files += ',';
        }
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      ;
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  singleonChange($event, question) {
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    let Isexe = false;
    let Is5oMB = false;   
    let IscrdDownload = false;

    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;


      if (file != null && (ext == 'exe')) {
        Isexe = true;        
      }
      else if (file != null && (ext == 'crdownload')) {
        IscrdDownload = true;
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }

    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else if (IscrdDownload) {
      this.commonService.ValidationBanner("The system does not support .crdownload files. Please choose a different file format to save the details.")
    }
    else {

    }



  }

  SaveIST_GI_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
    uploadData.append("Appid", '');
    uploadData.append("Application_Type_ID", this.Application_Type_ID);
    uploadData.append("Currency_ID", this.Currency_ID);
    return this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", uploadData);
  }

  GetIstGenInfoScreenConfigControls() {
    this.commonService.GetScreenConfigControls('SCR-001', '', '', (ScreenData) => {
      this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
    });
  }

}
